import { combineReducers } from 'redux';

import accounts from './accounts.reducer';
import classes from './classes.reducer';
import customers from './customers.reducer';
import dealers from './dealers.reducer';
import investors from './investors.reducer';
import servicingCompanies from './servicingCompanies.reducer';
import warehouseBankLines from './warehouseBankLines.reducer';
import warehouses from './warehouses.reducer';

const reducer = combineReducers({
  classes,
  customers,
  investors,
  accounts,
  warehouses,
  warehouseBankLines,
  dealers,
  servicingCompanies,
});

export default reducer;
